import {hideMultiStoneHaloMilgrain} from '../../../../utils/jewelry-validation'

export const validateMultiStoneHaloFields = (filters) => {
  let haloWidth = filters.side_stone_halo_width && filters.side_stone_halo_width === 'custom' ? 'side_stone_halo_custom_width' : 'side_stone_halo_width'
  const fieldNames = [
    'side_stone_halo_quality',
    'side_stone_halo_style',
    'side_stone_overlapping_setting',
    haloWidth,
    'side_stone_halo_setting_style'
  ]

  const fieldErrorMsgMapping = {
    'side_stone_halo_quality': 'Quality of Diamonds in Multi-Stone Halo',
    'side_stone_halo_style': 'Multi-Stone Halo Type',
    'side_stone_overlapping_setting': 'Overlapping Halos?',
    'side_stone_halo_width': 'Multi-Stone Halo Width (Per Row)',
    'side_stone_halo_custom_width': 'Multi-Stone Halo Custom Width',
    'side_stone_halo_setting_style': 'Multi-Stone Halo Setting Style',
    'side_stone_halo_milgrain': 'Multi-Stone Halo Milgrain'
  }

  // if multi stone halo milgrain is not hidden, then it should be validated
  if (!hideMultiStoneHaloMilgrain(filters)) {
    fieldNames.push('side_stone_halo_milgrain')
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/multi-stone-halo-fields/index.js